export default function DocumentsModifyController(
  $state,
  $stateParams,
  documentsService,
  FileUploader,
  NotificationService,
  notificationHelper,
  DOCUMENT_STATUSES,
) {
  var vm = this;

  vm.isLoading = false;
  vm.merchantId = $stateParams.merchantId;
  vm.documentId = $stateParams.documentId;
  vm.documentStatuses = DOCUMENT_STATUSES;
  vm.documentCategories = [];
  vm.updateDocumentFile = false;

  vm.uploader = new FileUploader();
  vm.fileToUpload = {};
  vm.document = {
    merchantId: vm.merchantId,
    status: DOCUMENT_STATUSES.ACTIVE,
    type: 'PDF',
  };

  vm.uploader.onAfterAddingFile = function(fileItem) {
    vm.fileToUpload = fileItem._file;
  };

  vm.init = init;
  vm.addDocument = addDocument;
  vm.editDocument = editDocument;

  init();

  function init() {
    getDocumentCategories();
    if (vm.documentId) {
      getDocumentById();
    }
  }

  function getDocumentCategories() {
    enableLoading();
    documentsService
      .getDocumentCategories()
      .then(function(res) {
        vm.documentCategories = res.data;
      })
      .catch(function(res) {
        notificationHelper.showError(res, 'Error getting document categories');
      })
      .finally(disableLoading);
  }

  function getDocumentById() {
    enableLoading();
    documentsService
      .getDocumentById(vm.merchantId, vm.documentId)
      .then(function(res) {
        vm.document = res.data;
      })
      .catch(function(res) {
        notificationHelper.showError(res, 'Error getting document data');
      })
      .finally(disableLoading);
  }

  function addDocument() {
    if (vm.isLoading) {
      return;
    }
    enableLoading();
    documentsService
      .addDocument(vm.merchantId, vm.document, vm.fileToUpload)
      .then(function() {
        NotificationService.success('Document successfully added');
        $state.go(
          'app.merchant',
          {
            merchantId: vm.merchantId,
            tab: 'services',
          },
          { reload: true },
        );
      })
      .catch(function(res) {
        notificationHelper.showError(res, 'Error adding document');
      })
      .finally(disableLoading);
  }

  function editDocument() {
    var file = vm.updateDocumentFile ? vm.fileToUpload : null;
    if (vm.isLoading) {
      return;
    }
    enableLoading();
    documentsService
      .updateDocument(vm.merchantId, vm.document, file)
      .then(function() {
        NotificationService.success('Document successfully updated');
        $state.go(
          'app.merchant',
          {
            merchantId: vm.merchantId,
            tab: 'services',
          },
          { reload: true },
        );
      })
      .catch(function(res) {
        notificationHelper.showError(res, 'Error adding document');
      })
      .finally(disableLoading);
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/documents/documents-modify.controller.js